import React, { useState, useEffect, useRef } from 'react';

function Footer() {
  const [views, setViews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasUpdated = useRef(false);

  useEffect(() => {
    if (hasUpdated.current) return;

    const updateAndFetchViews = async () => {
      try {
        hasUpdated.current = true;

        // First make POST request to increment
        await fetch('https://api.joel-fernandes.com/views/home', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        });

        // Then GET the updated count
        const response = await fetch('https://api.joel-fernandes.com/views/home', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) throw new Error('Network response was not ok');

        const data = await response.json();
        setViews(data.count);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    updateAndFetchViews();
  }, []);

  return (
    <footer className='footer'>
      <div className='footer-container'>
        <div className='footer-content'>
          <p className='footer-tagline'>Designed & built by Joel Fernandes</p>
          <a className='footer-contact' href='mailto:hello@joel-fernandes.com'>
            <svg
              className='footer-contact-icon'
              width='15'
              height='15'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              aria-hidden='true'
            >
              <rect x='2' y='4' width='20' height='16' rx='2' />
              <path d='m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7' />
            </svg>
            hello@joel-fernandes.com
          </a>
          <div className='footer-bottom'>
            <p className='footer-copyright'>© {new Date().getFullYear()} Joel Fernandes</p>
            {!loading && !error && views !== null && <span className='footer-separator'>·</span>}
            {!loading && !error && views !== null && (
              <div className='view-counter'>{views.toLocaleString()} views</div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
